var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-range-picker',{staticStyle:{"width":"100%"},attrs:{"name":"time_range","format":"YYYY-MM-DD HH:mm:ss"},on:{"change":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }